import PropTypes from 'prop-types';
import React, { useState } from 'react';

// material-ui
import {
    Button,
    CardContent,
    Grid,
    IconButton,
    Modal,
    Tooltip,
    Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import VenueService from 'services/VenueService';
import useApi from 'hooks/useApi';

const Body = React.forwardRef(({ revokeBoard, handleClose }, ref) => (
    <div ref={ref} tabIndex={-1}>
        <MainCard
            sx={{
                position: 'absolute',
                width: { xs: 280, md: 450 },
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            }}
            headersx={{
                p: '10px 18px'
            }}
            title="Revoke Board"
            content={false}
            secondary={
                <IconButton onClick={handleClose} size="large">
                    <CloseIcon fontSize="small" />
                </IconButton>
            }
        >
            <CardContent>
                <Typography>Do you really want to Revoke?</Typography>
                <Grid container justifyContent="flex-end" mt={2}>
                    <Grid item>
                        <Button
                            color="error"
                            variant="contained"
                            startIcon={<DoneRoundedIcon fontSize="small" />}
                            onClick={revokeBoard}
                        >
                            Revoke
                        </Button>
                    </Grid>
                </Grid>
            </CardContent>
        </MainCard>
    </div>
));

Body.propTypes = {
    modalStyle: PropTypes.object,
    handleClose: PropTypes.func
};

export default function RevokeAlert({ boardUuid, setReload, bookingUuid }) {

    const [open, setOpen] = React.useState(false);
    const [isDisabled, setIsDisabled] = useState(false);


    /* ---------- Event Callbacks ---------- */
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const revokeBoard = () => {
        if (isDisabled) return;
        setIsDisabled(true);

        setTimeout(() => {
            setIsDisabled(false);
        }, 2000);
        revokeBoardApi.execute(boardUuid, { booking_uuid: bookingUuid });
    }

    /* ---------- API Success Handlers ---------- */
    const revokeBoardHandler = () => {
        setReload(r => !r)
        setOpen(false);
    }

    /* ---------- API's ---------- */
    const revokeBoardApi = useApi(VenueService.revokeBoardStatusByUuid, revokeBoardHandler, true);

    return (
        <>
            <Tooltip placement="top" title="">
                <Button
                    color="primary"
                    sx={{
                        color: "error",
                    }}
                    variant="outlined"
                    onClick={handleOpen}
                    size="medium"
                >
                    Revoke
                </Button>
            </Tooltip>
            <Modal open={open} onClose={handleClose} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
                <Body revokeBoard={revokeBoard} handleClose={handleClose} />
            </Modal>
        </>
    );
}
